//libraries
import Vue from 'vue'
import axios from 'axios'

let resource = 'admin'
let resource_name = 'admin'
let resource_name_plural = 'admins'

let state = {
  client: null,
  admin: {},
  cases: {
    open: 0,
    on_hold: 0,
    close: 0
  },
  adminStatus: ''
}

state[resource + 's'] = []

//functions receive state
let getters = {
  today_attending_cases (state) {
    return parseInt(state.cases.open) + parseInt(state.cases.on_hold)
  },
  today_closed_cases  (state) {
    return state.cases.close
  },
  adminAccountStatus: state => state.adminStatus
}

//functions receive context and params
let actions = {
  async all ({ commit }, params) {
    try {
      commit('setItems', [])
      let res = await Vue.request.get(`${resource}`, {params: params.params || {}})
      if(res.data.success) {
        commit('setItems', res.data.resource)
        if(params.callback)
          params.callback(res.data)
      } else {
        if(params.callback)
          params.callback({error: `Error obteniendo ${resource_name_plural}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name_plural}.`})
      console.error(e)
    }
  },
  async get ({ commit }, params) {
    try {
      commit('setAdmin', {})
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        commit('setAdmin', res.data.resource)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name}.`})
      console.error(e)
    }
  },
  async create ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error creando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error creando ${resource_name}.`})
      console.error(e)
    }
  },
  async update ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`${resource}/${params[resource + '_id']}`, params)

      if(res.data.success && params.callback) {
        //commit('updateAdmin', res.data.resource)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando ${resource_name}.`})
      console.error(e)
    }
  },
  async destroy ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`${resource}/${params[resource + '_id']}`, {data: params})
      if(res.data.success) {
        if (params.callback) params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error eliminando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error eliminando ${resource_name}.`})
      console.error(e)
    }
  },
  async cases ({ commit }, params) {
    try {
      if(params.params.page == 1) commit('group/setCases', [], { root: true })
      params.params.limit = 6
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}/cases`, params)
      if(res.data.success && params.callback) {
        commit('group/concatCases', res.data.resource, { root: true })
        setTimeout(() => {
          params.callback(res.data)
        }, 500)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo casos del ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo casos ${resource_name}.`})
      console.error(e)
    }
  },
  async groups ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}/groups`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        let data = res.data.resource ? res.data.resource.map( el => {
          el.open = false
          el.openCasesCount = 0
          el.onHoldCasesCount = 0
          return el
        }) : []
        commit('group/setItems', data, { root: true })
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo grupos del ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo grupos del ${resource_name}.`})
      console.error(e)
    }
  },
  async addGroup ({ commit }, params) {
    try {
      let res = await Vue.request.put(`${resource}/${params[resource + '_id']}/group`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error agregando ${resource_name} al grupo.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error agregando ${resource_name} al grupo.`})
      console.error(e)
    }
  },
  async accounts ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}/accounts`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo cuentas del ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo cuentas del ${resource_name}.`})
      console.error(e)
    }
  },
  async removeGroup ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`${resource}/${params[resource + '_id']}/group`, {data: params})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error removiendo ${resource_name} del grupo.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error removiendo ${resource_name} del grupo.`})
      console.error(e)
    }
  },
  async associateAccount ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/${params[resource + '_id']}/assignAccount`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else {
        params.callback({error: `Error asociando cuenta.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error asociando cuenta.`})
      console.error(e)
    }
  },
  async removeAccount ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/${params[resource + '_id']}/removeAccount`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else {
        params.callback({error: `Error desasociando cuenta.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error desasociando cuenta.`})
      console.error(e)
    }
  },
  async sessions ({ commit }, params) {
    try {
      //commit('setAdmin', {})
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}/sessions`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        //commit('setAdmin', res.data.resource)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo actividad de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo actividad de  ${resource_name}.`})
      console.error(e)
    }
  },
  async getStatus ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/getStatus`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        commit('updateAdminStatus', res.data.resource)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo status de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo status de ${resource_name}.`})
      console.error(e)
    }
  },
  async setStatus ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`${resource}/setStatus`, params)
      if(res.data.success && params.callback) {
        commit('updateAdminStatus', res.data.resource)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando status de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando status de ${resource_name}.`})
      console.error(e)
    }
  },
  disconnectAdmin () {
    return new Promise(async (resolve, reject) => {
      if(state.admin.admin_id) {
        try {
          let params = {
            admin_id: state.admin.admin_id,
            status: 'offline',
          }
          let res = await Vue.request.patch(`${resource}/${params[resource + '_id']}`, params)

          resolve()
        } catch (e) {
          console.error(e)
          resolve()
        }
      } else {
        resolve()
      }
    })
  },
  disconnectAccountAdmin () {
    return new Promise(async (resolve, reject) => {
      if(state.admin.admin_id) {
        try {
          let params = {
            admin_id: state.admin.admin_id,
            status: 'offline',
            account_ids: 'all'
          }
          await Vue.request.patch(`${resource}/setAccountsStatus`, params)

          resolve()
        } catch (e) {
          console.error(e)
          resolve()
        }
      } else {
        resolve()
      }
    })
  },
  async countUnreadCases ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}/count_unread_cases`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo cuenta del ${resource_name} sin leer.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo cuenta del ${resource_name} sin leer.`})
      console.error(e)
    }
  },
  async countTodayCases ({ commit }, params) {
    try {
      if (!params[resource + '_id']) return
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}/count_today_cases`, {params: params.params || {}})
      if (res.data.success) {
        const { resource } = res.data
        state.cases.open = resource.open || 0
        state.cases.on_hold = resource.on_hold || 0
        state.cases.close = resource.close || 0
        if (params.callback) params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo casos de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo casos de ${resource_name}.`})
      console.error(e)
    }
  },
  async getQR ({ commit }, { params = {}, callback = () => {} }) {
    try {
      const res = await Vue.request.get(
        `${resource}/${params.adminId}/qr`,
        { params: { accountId: params.accountId } || '' }
      )
      const { data } = res

      if (!data.success) throw new Error('Ocurrió un error obteniendo el QR.')

      return callback(data)
    } catch (e) {
      console.error(e)

      const data = { error: e.message }

      return callback(data)
    }
  },
}

//functions receive state
let mutations = {
  setItems (state, items) {
    state[resource + 's'] = items
  },
  setAdmin (state, data) {
    state.admin = data
  },
  setClient (state, data) {
    state.client = data
  },
  updateAdminAttribute (state, data) {
    try {
      state.admin[data.attribute] = data.value
    } catch (e) {
      console.error(e)
    }
  },
  updateAdminStatus (state, data) {
    state.adminStatus = data
  },
  pushAdmin (state, admin) {
    state.admins.push(admin)
  },
  updateAdmin (state, admin) {
    let index = state[resource + 's'].findIndex(a => a.admin_id == admin.admin_id)
    
    if (index >= 0) {
      state[resource + 's'].splice(index, 1, admin)
    }
  },
  removeAdmin (state, admin) {
    let index = state.admins.findIndex(a => a.admin_id == admin.admin_id)
    if (index >= 0) {
      state.admins.splice(index, 1)
    }
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
